var defaultConfig = {
    backendUrl: 'https://api.quicksmart.ai',
    openAiKey: '',
    ENV: 'development',
    livekitUrl: 'wss://talkbot-klk047q5.livekit.cloud',
    livekitApiKey: '',
    livekitApiSecret: '',
    livekitTokenUrl: 'http://localhost:3001'
};
export var getEnvConfig = function () {
    if (typeof window === 'undefined')
        return defaultConfig;
    return {
        backendUrl: process.env.PUBLIC_BACKEND_URL || defaultConfig.backendUrl,
        openAiKey: process.env.PUBLIC_OPEN_AI_KEY || defaultConfig.openAiKey,
        ENV: process.env.NODE_ENV || defaultConfig.ENV,
        livekitUrl: process.env.LIVEKIT_URL || defaultConfig.livekitUrl,
        livekitApiKey: process.env.LIVEKIT_API_KEY || defaultConfig.livekitApiKey,
        livekitApiSecret: process.env.LIVEKIT_API_SECRET || defaultConfig.livekitApiSecret,
        livekitTokenUrl: process.env.LIVEKIT_TOKEN_URL || defaultConfig.livekitTokenUrl
    };
};
export var env = getEnvConfig();
